import React from "react";
import "./App.css";

function Footer() {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} NRN Review — Independent Customer Feedback Platform</p>
    </footer>
  );
}

export default Footer;
